export default {
    google_api_key: 'AIzaSyBGYurOXOAGXQP0-kP0oForIrJUnGzis5g',
    app_name: 'sight_seeing',
    grant_type: 'password',
    client_id: '0197213b-da7a-70e4-a7d1-c9247a75b685',
    secret_key: 'rZAzOFlAaDZxiIuMMJ3wLA822jdPANY3vNQTtwfe',
    base_url: 'https://voip-api.brandstofpas.app',
    api: {
        urls: {
            oauth: 'oauth/token',
            user: {
                info: 'api/v2/userinfo',
                permissions: 'api/v2/user/permissions'
            },
            configuration: 'api/v2/frontend/{name}/configurations',
            route: {
                splitRoute: 'api/v2/splitroute'
            }
        }
    },
    logging: {
        rollbar: {
            accessToken: '',
            captureUncaught: true,
            captureUnhandledRejections: true
        }
    }
}
